//Built-in libraries

//Third party libraries

import { ExclamationCircleIcon } from '@heroicons/react/24/outline';

//Custom components
import Button from '../UI/Button';

//Services

//Assets andd Miscellaneous

//Component Begin
export default function ErrorFallBack() {
  return (
    <div className='h-screen p-10 flex  flex-col gap-20'>
      <div className='w-full flex justify-center'>
        <img
          src='https://assets.seinterminal.com/images/logos/SEIN_Terminal_Logo_Color.png'
          className='h-26 w-36 fixed'
          alt='Sein Terminal Logo'
        />
      </div>
      <div className='flex flex-col justify-center items-center'>
        <div className='flex flex-col bg-white px-5 py-6 rounded-md max-w-xl text-center justify-center items-center shadow-lg'>
          <div className='bg-red-50 p-4 rounded-full my-4'>
            <ExclamationCircleIcon className='h-10 w-10 text-tertiaryColor-normal' />
          </div>
          <h1 className='m-0'>Uh oh! something went wrong</h1>
          <p className='mt-2 mb-5'>
            Sein Terminal has encountered an error. Please try again or If this problem persist, report an issue to support@sein.tech.
          </p>
          <div>
            <Button label='Reload page' btnStyle='btn-primary' type='button' onClick={() => window.location.reload()} />
          </div>
        </div>
      </div>
    </div>
  );
}
